import { render, staticRenderFns } from "./Community.ts.vue?vue&type=template&id=4f75a8be&"
import script from "./Community.ts.vue?vue&type=script&lang=ts&"
export * from "./Community.ts.vue?vue&type=script&lang=ts&"
import style0 from "./Community.ts.vue?vue&type=style&index=0&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports